import React, {useState} from "react";
import {Button, Input, ModalRequest, Select} from "../common";
import {BUTTON_TYPES} from "../../types";
import {useMutation, useQuery} from "react-query";

const DownloadModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  const [dateStart, setDateStart] = useState<string>('');
  const [dateEnd, setDateEnd] = useState<string>('');

  const { refetch } = useQuery(["downloadTable", dateStart, dateEnd], {
    refetchOnWindowFocus: false,
    enabled: false,
    onSuccess: ({ url }) => {
      const downloadUrl = new URL(`${process.env.REACT_APP_BASE_URL}${url}`);
      const link = document.createElement('a');
      link.href = downloadUrl?.href;
      link.setAttribute('download', `${Date.now()}.xlsx`);
      document.body.appendChild(link);
      link.click();
      onClose();
    }
  });

  const onDownload = () => {
    refetch()
  }

  return (
    <ModalRequest open={open} onClose={onClose} title="Скачать таблицу">
      <>
        <p className="text-[14px] leading-[24px] text-black font-medium mb-1">Период</p>
        <div className="flex items-center gap-2">
          <Input
            onChange={(e) => setDateStart(e.target.value)}
            value={dateStart}
            type="date"
            className="w-full"
          />
          <Input
            onChange={(e) => setDateEnd(e.target.value)}
            value={dateEnd}
            type="date"
            className="w-full"
          />
        </div>

        <p className="text-[14px] leading-[24px] text-black font-bold mt-4 mb-1">
          Тип файла: <span>Excel</span>
        </p>
        {/*<Select*/}
        {/*  value={[{ id: 1, label: 'Excel' }, { id: 2, label: 'Docs' }]}*/}
        {/*  activeData={{ id: 1, label: 'Excel' }}*/}
        {/*  onChange={(data) => console.log(data)}*/}
        {/*/>*/}

        <div className="mt-6 flex items-center">
          <Button title={'Скачать'} type={BUTTON_TYPES.SECONDARY} onClick={onDownload} />
          <Button title={'Отмена'} type={BUTTON_TYPES.GRAY} onClick={onClose} className="ml-2" />
        </div>
      </>
    </ModalRequest>
  )
};

export default DownloadModal;
